import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import { messageOf } from '../lib/errors';
import { useFormatDate } from '../lib/useSettings';

export default function DocumentsPage() {
  const { data, isLoading, error } = useQuery({ queryKey: ['documents'], queryFn: api.listDocuments });
  const fmt = useFormatDate();

  return (
    <div>
      <h1 className="mb-5 text-lg font-semibold">Documents</h1>
      {error && <p className="mb-3 text-sm text-red-600">{messageOf(error, 'Could not load documents')}</p>}
      {isLoading ? (
        <p className="text-sm text-slate-400">Loading…</p>
      ) : !data || data.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-300 p-12 text-center text-slate-400">
          No documents generated yet.
        </div>
      ) : (
        <div className="overflow-hidden rounded-xl border border-slate-200 bg-white">
          <table className="w-full text-sm">
            <thead className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-400">
              <tr>
                <th className="px-4 py-2">Title</th>
                <th className="px-4 py-2">Status</th>
                <th className="px-4 py-2">Kind</th>
                <th className="px-4 py-2">Hash</th>
                <th className="px-4 py-2">Created</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {data.map((d) => (
                <tr key={d.id} className="hover:bg-slate-50">
                  <td className="px-4 py-2">
                    <div className="font-medium">{d.title}</div>
                    <div className="font-mono text-[11px] text-slate-400">{d.id}</div>
                  </td>
                  <td className="px-4 py-2">{d.status}</td>
                  <td className="px-4 py-2">{d.envelopeId ? 'envelope' : 'generate-only'}</td>
                  <td className="px-4 py-2 font-mono text-[11px] text-slate-500">
                    {d.documentHash ? `${d.documentHash.slice(0, 20)}…` : '—'}
                  </td>
                  <td className="whitespace-nowrap px-4 py-2 text-slate-500">{fmt.dateTime(d.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
